import gql from 'graphql-tag';

export default gql`
  mutation ($title: String!, $content: String!, $startDate: Date!, $endDate: Date!, $image: String) {
    createAnnounce(
      record: { title: $title, content: $content, startDate: $startDate, endDate: $endDate, image: $image }
    ) {
      recordId
    }
  }
`;
